import jwtDecode from 'jwt-decode';
import { injectEnvsScript } from 'env';
import { apiInit, initAuthorized, socketInit } from '../utils/jarvisApiClient';
import { setUserPermissions } from 'utils/permissions';

const initAll = async access_token => {
  await injectEnvsScript();
  apiInit();
  socketInit();
  initAuthorized(access_token);
};

const authInitState = {
  auth: {
    isAuthenticated: false,
    isLogin: false,
    user: {},
    error: undefined
  },
  permission: []
};

const contentInitState = {
  actualStatus: [],
  beaconStatus: [],
  unreadNotificationsCount: 0
};

if (localStorage.access_token) {
  const currentTime = Date.now() / 1000;
  const { access_token, permissions } = localStorage;
  const decoded = jwtDecode(access_token);
  if (decoded.exp < currentTime) {
    localStorage.removeItem('access_token');
    socketInit(false);
    apiInit(false);
    authInitState.auth.user = {};
    authInitState.auth.isAuthenticated = false;
    authInitState.permission = [];
    window.location.href = '/login';
  }
  initAll(access_token);
  authInitState.auth.user = decoded;
  authInitState.auth.isAuthenticated = true;
  authInitState.permission = permissions;
  setUserPermissions(permissions);
}

export { authInitState, contentInitState };
